module.exports = __webpack_public_path__ + "static/media/massage-background.e2ec75ab.svg";